import cx from 'classnames';

import { Title } from './Title';
import styles from './Title.css';

const TitlePlugin = ({ className, TITLE_TAG, ...attributes } = {}) => ({
  renderElement: Title({
    className: cx(styles.title, className),
    TITLE_TAG,
    ...attributes,
  }),
});

export { TitlePlugin };
